import { SortableContainer } from 'react-sortable-hoc'

import CollectionItem from 'components/CollectionItem'

import s from './CollectionOrderableList.module.css'

function CollectionOrderableList({ removeItem, items, disabled, ...props }) {
  return (
    <ul className={s.container}>
      {items.map((item, index) => (
        <CollectionItem
          {...item}
          {...props}
          remove={removeItem ? () => removeItem(item) : null}
          disabled={disabled}
          index={index}
          key={item.modelSlug}
        />
      ))}
    </ul>
  )
}

const SortableCollectionOrderableList = SortableContainer(
  CollectionOrderableList
)

export default SortableCollectionOrderableList
